import { useEffect } from "react";

/**
 * Lightweight client-side SEO helper: updates document.title and the
 * meta description for public pages. The static Open Graph tags live in
 * public/index.html (social scrapers don't run JS); this keeps the title
 * fresh for Google and the browser tab on a per-route basis.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
  }, [title, description]);
}
